import React from 'react'
import { useNavigate } from 'react-router-dom'

import { DashboardPageViewModel, useDashboardPageViewModel } from './DashboardsPageViewModel'
import { EdifyButton } from '../../components/buttons'
import { useGlobalProvider } from '../../../providers/GlobalProvider'
import DashboardsDataGrid from './DashboardsDataGrid'
import DashboardsFilter from './DashboardsFilters'
import PageContainer from '../../components/page/PageContainer'

export const ROUTE_DASHBOARDS = '/dashboards'

export const DashboardsPage: React.FC = () => {
  return (
    <DashboardPageViewModel>
      <_Page />
    </DashboardPageViewModel>
  )
}

export const _Page: React.FC = () => {
  const vm = useDashboardPageViewModel()
  const { isGlobalUser } = useGlobalProvider()
  const navigate = useNavigate()
  const canCreate = isGlobalUser

  const renderRightItems = () => {
    if (canCreate) {
      return <EdifyButton title={'Add New Dashboard'} onClick={() => navigate(`${ROUTE_DASHBOARDS}/new`)} />
    }
  }

  return (
    <PageContainer
      title={'All Dashboards'}
      errorObj={vm.errorObj}
      noMaxWidth={true}
      renderRightItems={renderRightItems}
      breadCrumbs={[{ title: 'All Dashboards', to: `${ROUTE_DASHBOARDS}/all` }]}
    >
      <DashboardsFilter vm={vm} />
      <DashboardsDataGrid vm={vm} title={'Dashboard'} checkboxSelection={false} />
    </PageContainer>
  )
}
